<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="close">Bulk Duplicate Unit</modal-header>
    </div>
    Are you sure you want to duplicate units.
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, Duplicate"/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_bulk_copy_unit',
  mixins: [modalMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String
  },
  data: () => ({
  }),
  mounted () {},
  methods: {
    confirm: function () {
      this.$emit('confirmBulkCopyUnit')
      this.close()
    }
  }
}

</script>

<style lang="scss">
  .error {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-bulk-copy-unit.vue